"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseChannel = void 0;
var request_1 = require("./request");
var util_1 = require("../../util");
/**
 * CGI数据通道模板基类
 * 使用CGI提交都具有相似的流程 1、打包参数 2、发送请求 3、处理响应
 * 目标：后续CGI提交都可复用该通道
 *
 * @implements {IBaseChannel}
 */
var BaseChannel = /** @class */ (function () {
    function BaseChannel(options, defaultConfig) {
        this.options = options;
        this.defaultConfig = defaultConfig;
    }
    BaseChannel.prototype.dispose = function () {
        this.paramsPacker = undefined;
        this.responseHandler = undefined;
    };
    BaseChannel.prototype.sendMessage = function (message) {
        return __awaiter(this, void 0, void 0, function () {
            var error, content, requestUrl, method, contentType, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.paramsPacker || !this.responseHandler) {
                            error = "Channel Error, sendMessage failed paramsPacker:" + this.paramsPacker + ", responseHandler:" + this.responseHandler + " ";
                            util_1.ConnectionLog.error(error);
                            return [2 /*return*/, { error: error }];
                        }
                        content = this.paramsPacker.pack(message, this.options);
                        requestUrl = message.requestUrl, method = message.method, contentType = message.contentType;
                        return [4 /*yield*/, new request_1.Request().sendRequest(requestUrl !== null && requestUrl !== void 0 ? requestUrl : this.defaultConfig.requestUrl, method !== null && method !== void 0 ? method : this.defaultConfig.method, contentType !== null && contentType !== void 0 ? contentType : this.defaultConfig.contentType, content)];
                    case 1:
                        result = _a.sent();
                        // 3、处理结果
                        return [2 /*return*/, this.responseHandler.handle(result)];
                }
            });
        });
    };
    return BaseChannel;
}());
exports.BaseChannel = BaseChannel;
